export default "__VITE_ASSET__DqaElqHE__"